import React from "react";
import { connect } from "react-redux";
import { Box, IconButton } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { ApplicationState } from "../../redux/reducers";
import { IGuiaWizard } from "../../entities/guias/IGuiaWizard";
import { traducirButton } from "../../blocks/traductor";
import PostgeneracionGuiaView from "./PostgeneracionGuiaView";

interface StateProps {
    guiaWizard: IGuiaWizard;
}

type Props = StateProps;

const ConfirmacionGuiaStep = ({ guiaWizard }: Props) => {
    const history = useHistory();
    const createResult = guiaWizard.createResult;

    if (!createResult) {
        return null;
    }

    return (
        <Box>
            <PostgeneracionGuiaView createResult={createResult} />
            <Box display="flex" justifyContent="flex-end" alignItems="center" px={3} pb={3}>
                <IconButton
                    color="primary"
                    onClick={() => history.push("/")}
                    aria-label={traducirButton(11)}
                >
                    {traducirButton(11)}
                </IconButton>
            </Box>
        </Box>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    guiaWizard: state.guiaWizard
});

export default connect(mapStateToProps)(ConfirmacionGuiaStep);
